// extracted by mini-css-extract-plugin
export default {"container":"XY-z","list":"YY-z"};